/* src/app/notification-settings/location-settings-grid/notification-location/notification-location.component.scss */
.location {
  width: 328px;
  font-weight: normal;
  line-height: 16px;
  display: grid;
  grid-template-areas: "slic" "name" "address";
  row-gap: 1px;
}
.location div {
  height: 16px;
}
.location div:nth-child(1) {
  grid-area: slic;
  font-weight: 700;
}
.location div:nth-child(2) {
  grid-area: name;
  overflow: hidden;
  text-overflow: ellipsis;
}
.location div:nth-child(3) {
  grid-area: address;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*# sourceMappingURL=notification-location.component.css.map */
